import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

interface SidebarSearchProps {
  onClick?: () => void;
}

export const SidebarSearch: FC<SidebarSearchProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="flex items-center gap-2 h-10 px-2.5 py-2 rounded-full border border-community-text-on-bg/25 w-full cursor-pointer text-left transition-colors hover:bg-community-text-on-bg/10"
      aria-label={t('community.sidebar.search_placeholder')}
      onClick={onClick}
    >
      <MagnifyingGlassIcon className="size-5 shrink-0 text-community-text-on-bg/50" />
      <span className="text-[15px] font-medium tracking-[-0.13px] text-community-text-on-bg/50 md:text-[13px]">
        {t('community.sidebar.search_placeholder')}
      </span>
    </button>
  );
};
